import { _internalSetupAnalytics } from '@beeline/lk-utils';

import { APP_ANALYTICS_ID } from ':constants/app';

export const trackEvent = (event: string, params: any): void => {
  if (window.ym && APP_ANALYTICS_ID) {
    window.ym(APP_ANALYTICS_ID, 'reachGoal', event, params);
  }
  if (window._paq) {
    let paramsArr = params || [];
    if (typeof paramsArr !== 'object') {
      paramsArr = [paramsArr];
    } else if (!Array.isArray(paramsArr)) {
      paramsArr = Object.values(paramsArr);
    }
    window._paq.push(['trackEvent', event, ...paramsArr]);
  }
};

export const serviceTrackEvent = (
  eventAction: string,
  eventName?: string,
  eventValue?: any,
): void => {
  if (window._paq) {
    const serviceId = location.pathname.split('/')[1];
    window._paq.push([
      'trackEvent',
      serviceId ? `service_${serviceId}` : 'showcase',
      eventAction,
      eventName,
      eventValue,
    ]);
  }
};

export const analyticsSetUser = (userId: string, isExternal: boolean): void => {
  if (isExternal) {
    userId = `B-${userId}`;
  }
  if (window.ym && APP_ANALYTICS_ID) {
    window.ym(APP_ANALYTICS_ID, 'userParams', { UserID: userId });
  }
  if (window._paq) {
    window._paq.push(['setUserId', userId]);
  }
};
export const analyticsTrackPageView = (customTitle?: string): void => {
  if (!window._paq) return;

  let { href } = location;
  const splitHref = href.split('/');
  if (splitHref.length === 4) {
    if (!href.endsWith('/')) {
      href += '/';
    }
  } else if (href.endsWith('/')) {
    href = href.slice(0, -1);
  }
  window._paq.push(['setCustomUrl', href]);
  window._paq.push(['setDocumentTitle', customTitle ?? document.title]);
  window._paq.push(['trackPageView']);
};

_internalSetupAnalytics({
  pageView: analyticsTrackPageView,
  trackEvent: serviceTrackEvent,
});

window.scpTrackEvent = trackEvent;
